define("powergen/models/part-type",
  [],
  function() {
    "use strict";
    var PartType;

    PartType = DS.Model.extend({
      name: DS.attr('string')
    });


    return PartType;
  });